import React, { useState, useCallback, useRef, useEffect } from "react";
import {
    Box, Text, Button, Input, FormControl, FormErrorMessage, VStack, InputGroup, InputLeftAddon
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import StepHeader from "./StepHeader";
import { addsubuser, setdefaultsubuser } from "../../collection/ApiCollection";
import { Select as AntdSelect } from "antd";
import { cousntryCodesArr } from "../../utils/constants";
import { toast } from "react-toastify";
import { authtemplogin } from "../../store/Authentication";
import { nextStep } from "../../store/formSlice";
import { useProfileImage } from "../../store/ProfileImageContext";
import ProfileImageUpload from "../ProfileImageUpload";

const isValidPhoneNumber = value => /^\d{7,15}$/.test(value.replace(/\D/g, ""));

const LovedOnePhoneStep = () => {
    const dispatch = useDispatch();
    const { formData } = useSelector(state => state.form);
    const firstName = formData.firstName || "First Name";
    const loginData = useSelector(state => state.Authlogin.dataTemp?.userDetail ? state.Authlogin.dataTemp : {});
    const [phoneNumber, setPhoneNumber] = useState("");
    const [error, setError] = useState("");
    const [country, setCountry] = useState({ name: "US", code: "+1" });
    const [loading, setLoading] = useState(false);
    const inputRef = useRef(null);

    const { profileImage, saveProfileImage } = useProfileImage();

    useEffect(() => {
        inputRef.current?.focus();
    }, []);

    const handlePhoneChange = useCallback(e => {
        const value = e.target.value.replace(/\D/g, "");
        setPhoneNumber(value);
        if (error) setError("");
    }, [error]);

    const handleCountryCodeChange = useCallback(value => {
        const selected = cousntryCodesArr.find(c => c.name + c.code === value);
        if (selected) setCountry(selected);
    }, []);

    const validate = useCallback(() => {
        if (!phoneNumber.trim()) {
            setError("Phone number is required");
            return false;
        }
        if (!isValidPhoneNumber(phoneNumber.trim())) {
            setError("Enter a valid phone number");
            return false;
        }
        setError("");
        return true;
    }, [phoneNumber]);

    const handleSubmit = useCallback(
        async e => {
            e.preventDefault();
            if (loading) return;
            if (!validate()) return;
            setLoading(true);
            try {
                dispatch({
                    type: "form/updateFormData",
                    payload: { countryCode: country.code, phoneNumber: phoneNumber.trim() }
                });
                const { firstName: fullName, dateOfBirth, gender } = formData;
                let payload;
                if (!!profileImage) {
                    let data = new FormData();
                    data.append('fullName', fullName)
                    data.append('dateOfBirth', dateOfBirth)
                    data.append('gender', gender)
                    data.append('phoneNumber', Number(phoneNumber.trim()))
                    data.append('countryCode', country.code)
                    data.append('profileImage', profileImage)
                    payload = data;
                } else {
                    payload = { fullName, dateOfBirth, gender, phoneNumber: Number(phoneNumber.trim()), countryCode: country.code };
                }
                const res = await addsubuser(payload);
                if (res?.data?.data?._id) {
                    const req = { subUserId: res?.data?.data?._id };
                    const result = await setdefaultsubuser(req);
                    if (result.status === 200) {
                        const updatedAuthLogin = {
                            ...loginData,
                            userDetail: {
                                ...loginData.userDetail,
                                isSubUser: true
                            }
                        };
                        dispatch(authtemplogin(updatedAuthLogin));
                        toast.success(res?.data?.message);
                        dispatch(nextStep());
                    } else {
                        toast.error(
                            result?.response?.data?.message ||
                            result?.error ||
                            result?.message ||
                            "Something went wrong"
                        );
                    }
                }
            } catch (err) {
                setError(err?.response?.data?.message || err?.error || err?.message || "Something went wrong");
            } finally {
                setLoading(false);
            }
        },
        [country, phoneNumber, formData, dispatch, validate, loading, loginData]
    );
    return (
        <Box maxW={{ base: "100%", md: "3xl" }} mx="auto" p={{ base: 4, md: 6 }} textAlign="center">
            <StepHeader
                title="Loved One's Phone Number"
                subtitle={<>Where should we call <Text as="span" variant="highlighted">{firstName}</Text>?</>}
            />
            <VStack spacing={4} mb={4} mx={4} align="center">
                <ProfileImageUpload profileImage={profileImage} onImageChange={saveProfileImage} />
            </VStack>
            <form onSubmit={handleSubmit}>
                <VStack spacing={4} mb={4} mx={4} align="stretch">
                    <FormControl isInvalid={!!error} w="100%" maxW="500px" mx="auto">
                        <InputGroup w="100%">
                            <InputLeftAddon>
                                <AntdSelect
                                    value={country.name + country.code}
                                    onChange={handleCountryCodeChange}
                                    style={{ width: 100 }}
                                    dropdownStyle={{ zIndex: 1300 }}
                                    disabled={loading}
                                >
                                    {cousntryCodesArr.map(c => (
                                        <AntdSelect.Option key={c.name + c.code} value={c.name + c.code}>
                                            {c.name} ({c.code})
                                        </AntdSelect.Option>
                                    ))}
                                </AntdSelect>
                            </InputLeftAddon>
                            <Input
                                id="phoneNumber"
                                name="phoneNumber"
                                type="tel"
                                placeholder="Type the contact here"
                                value={phoneNumber}
                                onChange={handlePhoneChange}
                                w="100%"
                                isDisabled={loading}
                                ref={inputRef}
                                inputMode="numeric"
                                pattern="[0-9]*"
                                aria-label="Phone number"
                            />
                        </InputGroup>
                        <FormErrorMessage>{error}</FormErrorMessage>
                    </FormControl>
                </VStack>
                <Text fontSize={{ base: "14px", md: "18px" }} color="black" mb={4}>
                    This is the phone number where Sophie companions will reach your loved one.
                </Text>
                <Button
                    type="submit"
                    mt={4}
                    px="30px"
                    isDisabled={!phoneNumber.trim() || loading}
                    isLoading={loading}
                >
                    Continue
                </Button>
            </form>
        </Box>
    );
};

export default LovedOnePhoneStep; 